import type { BoxProps } from '@chakra-ui/react'
import { Box } from '@chakra-ui/react'
import React from 'react'

interface RadioStackProps {
  children: React.ReactNode
  variant?: string
  sx?: BoxProps['sx']
  labelsx?: BoxProps['sx']
  inputlabelwrappersx?: BoxProps['sx']
}

export const RadioStack = ({
  children,
  sx = {},
  variant = 'tile',
  labelsx = {},
  inputlabelwrappersx = {},
}: RadioStackProps) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridAutoFlow: {
          base: 'row',
          lg: 'column',
        },
        justifyContent: 'start',
        gap: variant === 'stackedTile' ? 0 : 2,
        ...sx,
      }}
    >
      {React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child, {
            variant,
            labelsx,
            inputlabelwrappersx,
          } as any)
        }
        return child
      })}
    </Box>
  )
}
